module.exports = __webpack_public_path__ + "assets/img/ozmo_logo.c5d85e0c.svg";